export const SAVINGS_BY_CATEGORY_PROPORTION_CHART_CASH_SAVINGS_COLOR =
  '#A4EFEB';
export const SAVINGS_BY_CATEGORY_PROPORTION_CHART_AFTER_TAX_SAVINGS_COLOR =
  '#4BC3BD';
export const SAVINGS_BY_CATEGORY_PROPORTION_CHART_PRE_TAX_SAVINGS_COLOR =
  '#31948F';
export const SAVINGS_BY_CATEGORY_PROPORTION_CHART_EDUCATION_SAVINGS_COLOR =
  '#246B68';
